/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Category2Map } from './Category2Map';
import {
    Category2MapFromJSON,
    Category2MapFromJSONTyped,
    Category2MapToJSON,
} from './Category2Map';
import type { ClassValue } from './ClassValue';
import {
    ClassValueFromJSON,
    ClassValueFromJSONTyped,
    ClassValueToJSON,
} from './ClassValue';

/**
 * An element of a synopsis
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * The name of the category
     * @type {string}
     * @memberof Category
     */
    name: string;
    /**
     * The percentage of calls which belong to this category
     * @type {number}
     * @memberof Category
     */
    percentage: number;
    /**
     * The number of contacts in this category
     * @type {number}
     * @memberof Category
     */
    numcontacts: number;
    /**
     * 
     * @type {Category2Map}
     * @memberof Category
     */
    children?: Category2Map;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category
     */
    customerSentiments?: Array<ClassValue>;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category
     */
    agentSentiments?: Array<ClassValue>;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category
     */
    resolutionRate?: Array<ClassValue>;
    /**
     * 
     * @type {Array<ClassValue>}
     * @memberof Category
     */
    repeatCalls?: Array<ClassValue>;
}


/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "percentage" in value;
    isInstance = isInstance && "numcontacts" in value;

    return isInstance;
}

export function CategoryFromJSON(json: any): Category {
    return CategoryFromJSONTyped(json, false);
}

export function CategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Category {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'percentage': json['percentage'],
        'numcontacts': json['numcontacts'],
        'children': !exists(json, 'children') ? undefined : Category2MapFromJSON(json['children']),
        'customerSentiments': !exists(json, 'customerSentiments') ? undefined : ((json['customerSentiments'] as Array<any>).map(ClassValueFromJSON)),
        'agentSentiments': !exists(json, 'agentSentiments') ? undefined : ((json['agentSentiments'] as Array<any>).map(ClassValueFromJSON)),
        'resolutionRate': !exists(json, 'resolutionRate') ? undefined : ((json['resolutionRate'] as Array<any>).map(ClassValueFromJSON)),
        'repeatCalls': !exists(json, 'repeatCalls') ? undefined : ((json['repeatCalls'] as Array<any>).map(ClassValueFromJSON)),
    };
}

export function CategoryToJSON(value?: Category | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'percentage': value.percentage,
        'numcontacts': value.numcontacts,
        'children': Category2MapToJSON(value.children),
        'customerSentiments': value.customerSentiments === undefined ? undefined : ((value.customerSentiments as Array<any>).map(ClassValueToJSON)),
        'agentSentiments': value.agentSentiments === undefined ? undefined : ((value.agentSentiments as Array<any>).map(ClassValueToJSON)),
        'resolutionRate': value.resolutionRate === undefined ? undefined : ((value.resolutionRate as Array<any>).map(ClassValueToJSON)),
        'repeatCalls': value.repeatCalls === undefined ? undefined : ((value.repeatCalls as Array<any>).map(ClassValueToJSON)),
    };
}

